<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="57rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.addTarget')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text>
          <div class="tab-group ty01">
            <v-tabs
              v-model="tab"
            >
              <v-tab value="tabCont1">{{t('message.department')}}</v-tab>
              <v-tab value="tabCont2">{{t('message.individual')}}</v-tab>
            </v-tabs>
          </div>
          <div class="content-box bg-none">
            <v-tabs-window v-model="tab">
              <v-tabs-window-item value="tabCont1">
                <div class="selected-group ty02 scrollbar">
                  <v-item-group selected-class="bg-active ">
                    <v-container>
                      <div class="list-group">
                        <div class="list-row" v-for="(item, i) in depts" :key="i">
                          <div class="list-txt">
                            <v-item v-slot="{ selectedClass, toggle }">
                              <v-card
                                :class="item.selected?'bg-active':''"
                                dark
                                @click="onClickRow('dept',i)"
                              >
                                <div class="txt">
                                  {{ item.deptName }}
                                </div>
                              </v-card>
                            </v-item>
                          </div>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item value="tabCont2">
                <div class="form-group col-ty">
                  <!--form-row-->
                  <div class="form-row">
                    <div class="row">
                      <div class="col">
                        <c-Input v-model="memberId" v-bind="InputName" class="size02" @input="getDataDebounced"/>
                      </div>
                      <div class="col">
                        <Select v-model="posIdx" v-bind="selectPos"/>
                      </div>
                      <div class="col">
                        <Select v-model="deptIdx" v-bind="selectDept"/>
                      </div>
                      <div class="col">
                        <Select v-model="shiftYn" v-bind="selectShift"/>
                      </div>
                      <div class="col">
                        <Select v-model="targetYn" v-bind="selectTarget"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selected-group scrollbar">
                  <v-item-group selected-class="bg-active ">
                    <v-container>
                      <div class="list-group">
                        <div class="list-row"
                             v-for="(item, i) in members"
                             :key="i"
                        >
                          <div class="list-txt">
                            <v-item v-slot="{ selectedClass, toggle }">
                              <v-card
                                :class="item.selected?'bg-active':''"
                                dark
                                @click="onClickRow('member',i)"
                              >
                                <div class="txt">
                                  {{item.memberInfo}}
                                </div>
                              </v-card>
                            </v-item>
                          </div>
                        </div>
                      </div>
                    </v-container>
                  </v-item-group>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn01 v-bind="btnCancel" @click="dialog=false"/>
          <c-btn02 v-bind="btnSave" @click="onClickConfirm"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import CompanyService from "@/services/company.service";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import _, {debounce} from 'lodash';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const tab = ref(null)
const memberId = ref('')
const posIdx = ref('')
const deptIdx = ref('')
const shiftYn = ref('')
const targetYn = ref('')
const headYn = ref('')
const members = ref([])
const depts = ref([])
const selectDept = ref({items: [{name: t('message.department'), value: ''}]})
const selectPos = ref({items: [{name: t('message.position'), value: ''}]})

//ui
const btnSave = ref({
  btnText: computed(() => t('message.save')),
})
const btnCancel = ref({
  btnText: computed(() => t('message.cancel')),
})
const InputName = ref({
  type: 'text',
  placeholder: computed(() => t('message.name')),
})
const selectTarget = {items: [{name: t('message.target'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]}
const selectHead = {items: [{name: t('message.organizationLeader'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]}
const selectShift = ref({items: [{name: t('message.shiftWork'), value: ''}]})

//hook
onBeforeUpdate (()=>{
  members.value = []
  depts.value = []
})

onUpdated(() => {
  if(dialog.value)
    getCompanyInfo()
})

//watch
const filterArray = computed(()=>(param) => {return _.filter(depts.value, {parentIdx: param}) })
watch(posIdx, (newValue) => {
  getData()
})
watch(deptIdx, (newValue) => {
  getData()
})
watch(shiftYn, (newValue) => {
  getData()
})
watch(targetYn, (newValue) => {
  getData()
})
watch(headYn, (newValue) => {
  getData()
})

//function
function getCompanyInfo(){
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    idx: companyIdx,
  }

  CompanyService.getCompany(params).then(
    (response) => {
      if(response.result){
        let posArr = {items: [{name: t('message.position'), value: ''}]}
        response.result.posList.forEach(function (item){
          posArr.items.push({name:item.treeName, value:item.idx})
        })
        selectPos.value = posArr

        let deptArr = {items: [{name: t('message.department'), value: ''}]}
        response.result.deptList.forEach(function (item){
          deptArr.items.push({name:item.treeName, value:item.idx})
        })
        selectDept.value = deptArr

        let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
        response.result.shiftList.forEach((item)=>{
          shiftArr.items.push({name:item.shiftName, value:item.idx})
        })
        selectShift.value = shiftArr
      }

      getData()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  let params2 = {idx: 0, companyIdx: companyIdx, treeType: 'dept'}
  CompanyService.getCompanyTreeList(params2).then(
    (response) => {
      let deptArr = []
      _.forEach(response.result, function (item){
        if(storeRef.popupType.value == '2' && storeRef.popupIdx.value == item.idx)  //2부서 3개인
          deptArr.push({idx:item.idx, deptName:item.treeName, selected:true, targetType:'2'})
        else
          deptArr.push({idx:item.idx, deptName:item.treeName, selected:false, targetType:'2'})
      })
      depts.value = deptArr
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function getData(){
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
    memberId: memberId.value,
    posIdx: posIdx.value,
    deptIdx: deptIdx.value,
    shiftIdx: shiftYn.value,
    targetYn: targetYn.value,
    headYn: headYn.value,
  }

  MemberService.getMemberListFilter(params).then(
    (response) => {
      if(response.result){
        let memberArr = []
        _.forEach(response.result, function (item){
          if(storeRef.popupType.value == '3' && storeRef.popupIdx.value == item.idx)   //2부서 3개인
            memberArr.push({idx:item.idx, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:true, targetType:'3'})
          else
            memberArr.push({idx:item.idx, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false, targetType:'3'})
        })
        members.value = memberArr
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickRow(type, i){
  let tempArr = depts.value
  if(type == 'member')
    tempArr = members.value

  const selected = tempArr[i].selected
  _.forEach(tempArr, function (val, key){
    if(key == i)
      val.selected = true
    else
      val.selected = false
  })
}

function onClickConfirm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else {
    dialog.value = false
    if(tab.value == 'tabCont1')
      emit('confirm', _.filter(depts.value, {selected: true}))
    else
    if(tab.value == 'tabCont2')
      emit('confirm', _.filter(members.value, {selected: true}))
  }
}

const getDataDebounced = debounce(() => {
  //if (!memberId.value || memberId.value.length < 2) return
  getData()
}, 500)
</script>


<style lang="scss">
</style>
